import '../App.css';

const CardGamesApp = () => {
    return (
        <div>
        <div className="navSpace"></div>
        <div className="appPages">
        <iframe title="Card Games App" src="https://play-card-games.netlify.app/" width="100%" height="99.4%" ></iframe>
        </div>
        </div>
    )
}
export default CardGamesApp